import { reactive } from 'vue';


const validation = reactive({
    invalid: [],
    valid: [],
    nullable: [],
});

//? checking conditions to enable or disable form login button
const checkForm = (data) => {
    let inValLength = validation.invalid.length
    let formInputs = Object.keys(data)
    let formNulls = Object.keys(data).filter((input) => eval(`data.${input}`) === null)
    let nullables = validation.nullable
    let notNullable = []


    let check = []
    if (nullables.length) {
        for (let nullable of nullables) {
            for (let [index, formInput] of formInputs.entries()) {
                if (nullable === formInput) {
                    delete formInputs[index]
                    break;
                }
                else if (!formInput) break
                else notNullable.push(formInput)
            }
        }
        notNullable = [... new Set(notNullable)]
        let notNullableInvalids = notNullable.flatMap(item => {
            let catchInValid = validation.invalid.includes(item)
            return catchInValid
        })
        //? removing falsy values from array
        check = notNullableInvalids.filter(Boolean)

    }
    let formInputsNulls = notNullable.map(field => formNulls.includes(field))
    let nullCheck = formInputsNulls.filter(Boolean)

    console.log("data in validator fn: ::")
    console.log(inValLength);
    console.log(check.length)
    console.log(nullCheck.length)

    if (!inValLength && !check.length && !nullCheck.length) {
        return true
    } else return false

}

//? adding and removing form fields from valid and invalid state
const setFormVal = (data) => {
    if (validation.invalid.length) {
        const newInvalid = validation.invalid.filter(
            (error) => error.field !== data.field,
        );
        validation.invalid = newInvalid;
    }
    if (validation.valid.length) {
        const newValid = validation.valid.filter(
            (item) => item.field !== data.field,
        );
        validation.valid = newValid;
    }

    console.log("validation data");
    console.log(validation);
    return;
};

// event handler for valError event
const valError = (input, data, nullables) => {

    if (!nullables instanceof Array) return console.error("expects 3rd param to be type Array")
    validation.nullable = nullables;
    setFormVal(input);
    validation.invalid = [...validation.invalid, input];
    let check = checkForm(data);

    if (check) return false;
    return true;
};

const valSuccess = (input, data, nullables) => {
    if (!nullables instanceof Array) return console.error("expects 3rd param to be type Array")
    validation.nullable = nullables;
    setFormVal(input);
    validation.valid = [...validation.valid, input];
    let check = checkForm(data);
    if (check) return false;
    return true;
};


export default {
    checkForm,
    valError,
    valSuccess,
};
